export const columns = [
  {
    dataField: "timestamp",
    text: "Date",
    props: {
      width: 180,
    },
  },
  {
    dataField: "message",
    text: "Message",
    props: {
      width: 180,
    },
  },
  {
    dataField: "empty",
    text: "",
    props: {
      width: 180,
    },
  },
];
